import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Security from "./components/Security";
import IntellectualProperty from "./components/IntellectualProperty";
import HowTo from "./components/HowTo";
import CyberneticHardware from "./components/CyberneticHardware";
import MessageMap from "./components/MessageMap";
import PremiumGrid from "./components/PremiumGrid";
import Login from "./components/Login";
import TokenPurchase from './components/TokenPurchase';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Report from './components/ReportPage';
import Mobile from './components/Mobile';
import FeedbackPage from './components/FeedbackPage';
import ReportPage from "./components/ReportPage";
import ShareAccessCode from './components/ShareAccessCode';
import FAQ from './components/FAQ'; 

import "./styles/global.css";
import "./styles/share-access-code.css";
const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/security" element={<Security />} />
        <Route path="/ip" element={<IntellectualProperty />} />
        <Route path="/howto" element={<HowTo />} />
        <Route path="/hardware" element={<CyberneticHardware />} />
        <Route path="/map" element={<MessageMap />} />
        <Route path="/map-premium" element={<PremiumGrid />} />
        <Route path="/purchase" element={<TokenPurchase />} />
        <Route path="/report" element={<ReportPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/omega-inbox" element={<ShareAccessCode />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;